/**
 * Mock API service for node creation
 * This will be replaced with actual API calls in the future
 */

// Simulate API call delay
const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

// Mock API response based on operation type
export const mockApiCall = async ({ parentNodeId, parentNodeContent, parentNodeType, operation }) => {
  // Simulate network delay
  await delay(500);
  console.log('we are in mock api call', 'parentNodeId',  parentNodeId, 'parentNodeContent', parentNodeContent, 'parentNodeType', parentNodeType, 'operation', operation);

  // Default response structure
  let response = {
    content: '',
    imageUrl: null
  };
  
  // Generate response based on operation and parent node type
  if (parentNodeType === 'textNode') {
    switch (operation) {
      case 'summary':
        response.content = `This is a summary of the text: "${parentNodeContent.substring(0, 50)}..."`;
        break;
      case 'short-form':
        response.content = `Short version: "${parentNodeContent.substring(0, 30)}..."`;
        break;
      case 'expand':
        response.content = `${parentNodeContent} Additionally, this is expanded content that provides more context and details about the original text.`;
        break;
      case 'sentiment':
        response.content = `Sentiment analysis: ${Math.random() > 0.5 ? 'Positive' : 'Negative'}`;
        break;
      case 'classify':
        response.content = `Classification: ${['News', 'Opinion', 'Technical', 'Creative'][Math.floor(Math.random() * 4)]}`;
        break;
      case 'create-action-prompt':
        response.content = `Prompt for action: ${parentNodeContent}`;
        break;
      default:
        response.content = 'Operation not supported';
    }
  } else if (parentNodeType === 'imageNode') {
    switch (operation) {
      case 'describe':
        response.content = 'This image appears to show content that would be described here by the API.';
        break;
      case 'tag':
        response.content = 'Tags: #image #content #analysis #tags';
        break;
      case 'sentiment':
        response.content = `Image sentiment: ${Math.random() > 0.5 ? 'Positive' : 'Neutral'}`;
        break;
      case 'classify':
        response.content = `Image classification: ${['Portrait', 'Landscape', 'Abstract', 'Document'][Math.floor(Math.random() * 4)]}`;
        break;
      default:
        response.content = 'Operation not supported';
    }
  } else if (parentNodeType === 'promptNode') {
    switch (operation) {
      case 'submit-prompt':
        response.content = `Prompt submitted: "${parentNodeContent}"`;
        break;
      case 'test-action':
        response.content = `Test result for: ${parentNodeContent}`;
        break;
      default:
        response.content = 'Operation not supported';
    }
  }
  
  return response;
};

export async function mockSyncGraph(graph) {
  await delay(500);
  console.log('Mock sync graph', graph);
  return { status: 'ok' };
}
